export const rulesMap = {
  hide: {
    title: "隐藏规则",
    titleTip: "为选择的字段设置条件，当表单满足条件时隐藏这些字段。",
    conditionTip: "满足条件时隐藏",
    newTip: "新建时隐藏",
    icon: "hide"
  },
  disabled: {
    title: "只读规则",
    titleTip: "为选择的字段设置条件，当表单满足条件时使这些字段只读。",
    conditionTip: "满足条件时只读",
    newTip: "新建时只读",
    icon: "disabled"
  },
  required: {
    title: "必填规则",
    titleTip: "为选择的字段设置条件，当表单满足条件时使这些字段必填。",
    conditionTip: "满足条件时必填",
    newTip: "新建时必填",
    icon: "required"
  },
  mutiUnique: {
    title: "唯一规则",
    titleTip: "指定多个字段，使该工作表中的记录的这些字段组合的值是唯一的。",
    conditionTip: "满足条件时唯一",
    newTip: "新建时唯一",
    icon: "mutiUnique"
  },
  reasonable: {
    title: "可保存规则",
    titleTip: "指定字段在满足条件时才可保存。",
    conditionTip: "满足条件才可保存",
    icon: "reasonable"
  }
}

const mapKey = Object.keys(rulesMap)

export function getEmptyRules() {
  return mapKey.reduce((acc, cur) => {
    acc[`${cur}Rules`] = []
    return acc
  }, {})
}

export const labelMap = mapKey.map(i => ({
  label: rulesMap[i].title,
  value: i,
  icon: rulesMap[i].icon
}))

export const ruleFields = {
  hide: {
    cidList: {
      title: "隐藏字段"
    },
    filters: {
      title: "满足以下条件时隐藏",
      tip: " 请先设置隐藏字段"
    }
  },
  disabled: {
    cidList: {
      title: "只读字段"
    },
    filters: {
      title: "满足以下条件时只读",
      tip: " 请先设置只读字段"
    }
  },
  required: {
    cidList: {
      title: "必填字段"
    },
    filters: {
      title: "满足以下条件时必填",
      tip: " 请先设置必填字段"
    }
  },
  mutiUnique: {
    name: {
      tip: "请填写规则名"
    },
    cidList: {
      title: "唯一的字段组合",
      tip: "该工作表中的记录的这些字段组合的值是唯一的。"
    },
    filters: {
      title: "满足以下条件时唯一",
      tip: " 请先设置唯一的字段组合"
    }
  },
  reasonable: {
    name: {
      tip: "请填写规则名"
    },
    filters: {
      title: "可保存的条件",
      tip: "指定字段在满足条件时才可保存。"
    }
  }
}
export const setRulesContent = {
  hide: {
    title1: "隐藏字段",
    title2: "满足以下条件时隐藏",
    tip: " 请先设置隐藏字段"
  },
  disabled: {
    title1: "不可编辑字段",
    title2: "满足以下条件时不可编辑",
    tip: " 请先设置不可编辑字段"
  },
  required: {
    title1: "必填字段",
    title2: "满足以下条件时必填",
    tip: " 请先设置必填字段"
  },
  mutiUnique: {
    title1: "多字段唯一的字段组合",
    tip: "该工作表中的记录的这些字段组合的值是唯一的。"
  },
  reasonable: {
    title1: "可保存的条件",
    tip: "指定字段在满足条件时才可保存。"
  }
}
